import { call, select, takeLatest } from 'redux-saga/effects';
import { fetchClinicalTrialAffiliates } from '@api/ClinicalTrialAffiliates';
import { actions } from './clinicalTrialAffiliates.slice';
import { Resp, dispatch } from '../helpers';
import { selectAuthState } from '@restore/auth/auth.slice';
export function* fetchClinicalTrialAffiliatesWorker() {
  try {
    const authState: ReturnType<typeof selectAuthState> =
      yield select(selectAuthState);

    if (authState?.data?.selectedRole) {
      const response: Resp<typeof fetchClinicalTrialAffiliates> = yield call(
        fetchClinicalTrialAffiliates,
        authState.data.selectedRole
      );
      yield dispatch(
        actions.fetchClinicalTrialAffiliatesSuccess(response.data)
      );
    }
  } catch (error) {
    yield dispatch(actions.fetchClinicalTrialAffiliatesFailure(error as Error));
  }
}

export function* clinicalTrialAffiliatesSaga() {
  yield takeLatest(
    actions.fetchClinicalTrialAffiliates.type,
    fetchClinicalTrialAffiliatesWorker
  );
}
